<template>
  <div>
    <div id="recaptcha_ko" v-show="locale == `ko`">
      <div
        class="g-recaptcha"
        :data-sitekey="rcapt_sig_key"
        ref="recaptcha_ko"
        id="recaptcha_ko"
      ></div>
    </div>
    <div id="recaptcha_ch" v-show="locale == `ch`">
      <div
        class="g-recaptcha"
        :data-sitekey="rcapt_sig_key"
        ref="recaptcha_ch"
        id="recaptcha_ch"
      ></div>
    </div>
    <div id="recaptcha_en" v-show="locale == `en`">
      <div
        class="g-recaptcha"
        :data-sitekey="rcapt_sig_key"
        ref="recaptcha_en"
        id="recaptcha_en"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rcapt_sig_key: this.$isDevServer
        ? "6LeiYOAUAAAAADdnn73t4Qwg6jZNhRAA-JGRpzXS"
        : "6LfOpkcUAAAAAG4JscMvBbFfTpRHbPaUJQcE4WYE",
      rcapt_id: null,
      rcapt_id_ko: null,
      rcapt_id_en: null,
      rcapt_id_ch: null,
    };
  },
  computed: {
    locale() {
      switch (this.$i18n.locale) {
        case "ko":
          return "ko";
        case "ch":
          return "ch";
        case "en":
          return "en";
        default:
          return "ko";
      }
    },
  },
  mounted() {
    if (window.grecaptcha) {
      this.rcapt_id_ko = grecaptcha.render(this.$refs.recaptcha_ko, {
        sitekey: this.rcapt_sig_key,
        hl: "ko",
      });
      this.rcapt_id_ch = grecaptcha.render(this.$refs.recaptcha_ch, {
        sitekey: this.rcapt_sig_key,
        hl: "zh-CN",
      });
      this.rcapt_id_en = grecaptcha.render(this.$refs.recaptcha_en, {
        sitekey: this.rcapt_sig_key,
        hl: "en",
      });
      this.localeInit(this.locale);
    } else {
      this.$alert(this.$t("signup.error.capcha"));
    }
  },
  watch: {
    locale() {
      this.localeChange(this.locale);
    },
  },
  methods: {
    localeInit(locale) {
      this.localeChange(locale);
    },
    localeChange(locale) {
      switch (locale) {
        case "ko":
          this.rcapt_id = this.rcapt_id_ko;
          break;
        case "ch":
          this.rcapt_id = this.rcapt_id_ch;
          break;
        case "en":
          this.rcapt_id = this.rcapt_id_en;
          break;
        default:
          this.rcapt_id = this.rcapt_id_ko;
          break;
      }
      this.$emit("locale-change-event", this.rcapt_id);
    },
  },
};
</script>
<style></style>
